/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: tracking.js
 */
$.namespace('SCS.tracking');

/**
 * Track page views when some of the content is changing,
 * e.g. when replacing content with AJAX responses
 */
SCS.tracking.trackPartialPageView = function (tabname) {
	SCS.portal.datalayer.pushPagePath(tabname, true);
	SCS.portal.datalayer.trackPageView();
	SCS.portal.datalayer.popPagePath();
};

/**
 * Setting pageName suffixed with tabname for landing tab
 */
SCS.tracking.setLandingTabName = function (tabname) {
	SCS.portal.datalayer.pushPagePath(tabname, true);
};



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/tracking.js
// module id = 111
// module chunks = 0